export default {
  mounted() {
    this.$el.__tfx_vue_component = this
  },
  beforeUnmount() {
    delete this.$el.__tfx_vue_component
  }
}
